export default {
    methods: {
        async loginXByCodeRegister(fbdb,schoolId,studentCode,studentRegister){
            if(!studentCode || (studentCode && studentCode=='')){
               //alert("Та бүртгэлтэй сурагчийн кодоо оруулна уу");
               return -1;
             }
             if(!studentRegister|| (studentRegister && studentRegister=='')){
               //alert("Та бүртгэлтэй регистерээ оруулна уу");
               return -2;
             }
            var stsdata = await fbdb
                 .collection("/schools/"+schoolId+"/students")
                 .where("code", "==", studentCode.toLowerCase())
                 .where("register", "==", studentRegister.toLowerCase())
                 .limit(1)
                 .get();
 
           if (!stsdata.empty) {
             var studentDoc = stsdata.docs[0];
             if(studentDoc != null && studentDoc.exists && studentDoc.data() != null) {
     
                 var schoolDoc = await studentDoc.data().school.get();
                 if(schoolDoc.exists){
                     let schoolData = studentDoc.data().school;
                    //  this.school = schoolData;
                    //  this.school.ref = schoolDoc.ref;
                     this.schoolId = schoolDoc.id;

                     this.student = studentDoc.data();
                     this.student.id = studentDoc.id;
                     this.student.ref = studentDoc.ref;
                     this.accessfree = true;
                    // this.schools.push(this.school);
                     await this._getLesssonTest();
                     this.loading=false;
                     return 1;
                 }
             } 
           } 
           else {
             this.loading=false;
            //  alert(
            //    "Таны регистрийн дугаар болон код зөрж байна. Та анги удирдсан багшдаа xандана уу!"
            //  );
             return -3;
           }
         },
         _getXSchools(fbdb){
            fbdb.collection("schools")
            .get()
            .then(querySnapshot=> {
                querySnapshot.forEach(async schoolData=> {       
                    let xschool =schoolData.data();
                    xschool.id = schoolData.id;
                    xschool.ref = schoolData.ref;
                    this.schools.push(schoolData);
                });
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });
          },
        _getXSchoolsXX(fbdb){
            fbdb.collection("schools")
            .get()
            .then(querySnapshot=> {
                querySnapshot.forEach(async schoolData=> {       
                  var datas = await fbdb.collection("schools/"+schoolData.id+"/teachers")
                  .where("email", "==", this.userProfile.email)
                  .limit(1)
                  .get();
                  if(!datas.empty){
                     var userObj=datas.docs[0];
                    if(userObj.user!=null){
                      schoolData.data().found=false;
                    }
                    else{
                      schoolData.data().found=true;
                      this.school =schoolData.data();
                      this.school.id = schoolData.id;
                      this.school.ref = schoolData.ref;
                      this.schools.push(schoolData);
                    }
                  }     
                });
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });
          },
    },
}